import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getToken, setToken } from "../../slices/app";
export const useToken = () => {
    const dispatch = useDispatch();
    const value = useSelector(getToken);
    const update = useCallback((updatedValue) => {
        dispatch(setToken(updatedValue));
    }, [dispatch]);
    return [value, update];
};
